<template>
  <div class="hw-donut" :style="ringStyle">
    <div class="hw-donut-hole" :style="holeStyle">
      <strong>{{ value }}</strong>
      <small>{{ caption }}</small>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { donutStyle } from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/hrWorkforce'

const props = defineProps({
  items: { type: Array, required: true },
  total: { type: Number, required: true },
  value: { type: [String, Number], default: '' },
  caption: { type: String, default: '' },
  size: { type: Number, default: 130 },
  hole: { type: Number, default: 86 }
})

const ringStyle = computed(() => ({ ...donutStyle(props.items, props.total), width: props.size + 'px', height: props.size + 'px' }))
const holeStyle = computed(() => ({ width: props.hole + 'px', height: props.hole + 'px' }))
</script>

<style scoped>
.hw-donut {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.hw-donut-hole {
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.1;
}
.hw-donut-hole strong {
  font-size: 1.4rem;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}
.hw-donut-hole small {
  color: #64748b;
  font-size: 0.7rem;
}
</style>
